import { render } from "./ConversionesView.vue?vue&type=template&id=4b185c4a"
import script from "./ConversionesView.vue?vue&type=script&lang=js"
export * from "./ConversionesView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\WGitHub\\Kubber\\kubber\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__